import { useContext } from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { iconButtonStyles } from "../../../../components/Modal/ModalHeader";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import toastContext from "../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import CopyReportIcon from "../../../../components/SVGComponents/CopyReportIcon";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";

const CopyReport = () => {
  const { editorRef } = useContext(studyReportContext);
  const { disableCopyButton, isAgenticTab } = useContext(
    AgenticReportingContext,
  );
  const { showToastv2 } = useContext(toastContext);
  const copyReportToClipboard = () => {
    if (editorRef && editorRef.current) {
      editorRef.current.editor.commands.exec("copy");
      showToastv2(TOAST_TYPE.SUCCESS, "Report Copied Successfully");
    }
  };

  return (
    <CustomToolTipHost
      content={"Copy"}
      id="Copy"
      tooltipProps={{
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
      }}
    >
      <div
        className="highlight-tool-llm"
        styles={iconButtonStyles}
        onClick={() => {
          if (!disableCopyButton && isAgenticTab) copyReportToClipboard();
        }}
        style={{
          cursor: `${!disableCopyButton && isAgenticTab ? "pointer" : "not-allowed"}`,
        }}
        aria-label="Copy"
      >
        <CopyReportIcon copyAllowed={!disableCopyButton && isAgenticTab} />
      </div>
    </CustomToolTipHost>
  );
};

export default CopyReport;
